import {IAttributes, IFilterService, INgModelController, IRootElementService, IScope} from "angular";
import {Optional} from "../../util/Optional";

export const InputNumberFormat = "numberFormat";

/** @ngInject */
export function inputNumberFormat($filter: IFilterService) {
    return {
        restrict: "A",
        require: "ngModel",
        link($scope: IScope, $elem: IRootElementService, $attr: IAttributes, modelCtrl: INgModelController) {

            let decimals: number;

            const watcher = $scope.$watch<number>($attr.numberFormat, (value) => {
                decimals = value == null ? 0 : value;
            });

            $scope.$on("$destroy", watcher);

            const min = $attr.min == null ? Number.MIN_SAFE_INTEGER : $scope.$eval($attr.min);
            const max = $attr.max == null ? Number.MAX_SAFE_INTEGER : $scope.$eval($attr.max);

            // Ensures that only numbers can be input
            const stripIllegalCharacters = (text: string) => {
                if (text != null) {
                    text = checkDecimalPlaces(text);
                    // Remove non-numbers from the String
                    const transformedInput = text.replace(/[^0-9|^\.-]/g, "");
                    if (transformedInput !== text) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return transformedInput;
                }
                return null;
            };

            modelCtrl.$parsers.unshift(stripIllegalCharacters);

            const checkDecimalPlaces = (text: string) => {
                const split = text.split(".");
                if (split.length > 1) {
                    const dp = split[1].length;
                    if (dp > 2) {
                        return split[0] + "." + split[1].substring(0, 2);
                    }
                }
                return text;
            };

            const convertToNumber = (data: string) => {
                // Attempt to convert user input into a numeric type to store
                // as the model value (otherwise it will be stored as a string)
                // NOTE: Return null to indicate that a parse error has occurred
                //       (i.e. bad user input)
                const parsed = parseFloat(data);
                return !isNaN(parsed) ? parsed : null;
            };

            modelCtrl.$parsers.push(convertToNumber);

            const format = (data: number) => {
                // convert data from model format to view format
                if (data == null) {
                    return data;
                }
                return $filter("number")(data, decimals); // converted
            };

            modelCtrl.$formatters.push(format);

            $elem.on("focus", () => {
                const rawViewValue = $elem.val() as string;
                Optional.of(rawViewValue)
                        .map(stripIllegalCharacters)
                        .map(convertToNumber)
                        .ifPresent(val => $elem.val(val))
                        .ifEmpty(() => $elem.val(""));
            });

            const formatViewValue = () => {
                const rawViewValue = $elem.val() as string;
                Optional.of(rawViewValue)
                        .map(stripIllegalCharacters)
                        .map(convertToNumber)
                        .map(format)
                        .ifPresent(val => $elem.val(val))
                        .ifEmpty(() => $elem.val(""));
            };

            $elem.on("blur", () => {
                // Apply formatting on the stored model value for display
                formatViewValue();
            });

            modelCtrl.$validators.min = (modelValue: number, viewValue: string) => {
                return modelValue == null || modelValue >= min;
            };

            modelCtrl.$validators.max = (modelValue: number, viewValue: string) => {
                return modelValue == null || modelValue <= max;
            };
        }
    };
}
